// RFC 4180 CSV serialiser. Quotes any cell containing comma / quote /
// newline; doubles up embedded quotes. Used by report exports + the
// UTM-flagged-row download.

export function toCsv(
  headers: string[],
  rows: ReadonlyArray<ReadonlyArray<string | number>>,
): string {
  const cells = (line: ReadonlyArray<string | number>) =>
    line
      .map((c) => {
        const s = typeof c === "number" ? String(c) : c;
        if (/[",\r\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
        return s;
      })
      .join(",");
  return [cells(headers), ...rows.map(cells)].join("\r\n");
}
